module.exports = __webpack_public_path__ + "img/no-tag4.927e89be.png";